import type { FaireProductEntity } from "../../entity_types/product";

export const atc_nf_chunks_4: FaireProductEntity = {
  token: "atc_nf_chunks_4",
  type: "product",
  name: "Box Claw in Flower Power",
  brandName: "Chunks",
  imageUrl:
    "https://cdn.shopify.com/s/files/1/0510/2698/5143/products/Claw-FlowerPower-ClearGreen-WBG-web-1.jpg?v=1664584639",
  priceDollars: 20.95,
  msrpDollars: 42,
  description: "ATC migration seed product",
  tags: ["hair", "accessories", "chunks"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
